import type { IconData } from '@stacksjs/iconify-core'

export const vectorSquareAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 22a2 2 0 1 1 2-2a2.003 2.003 0 0 1-2 2M4 6a2 2 0 1 1 2-2a2.003 2.003 0 0 1-2 2m16 0a2 2 0 1 1 2-2a2.003 2.003 0 0 1-2 2m0 16a2 2 0 1 1 2-2a2.003 2.003 0 0 1-2 2m0-2.002\"/><rect width=\"10\" height=\"10\" x=\"7\" y=\"7\" fill=\"currentColor\" opacity=\".5\" rx=\"1\"/><path fill=\"currentColor\" d=\"M18.278 5a1.94 1.94 0 0 1 0-2H5.722a1.94 1.94 0 0 1 0 2zM20 18a2 2 0 0 1 1 .278V5.722a1.94 1.94 0 0 1-2 0v12.556A2 2 0 0 1 20 18M4 18a2 2 0 0 1 1 .278V5.722a1.94 1.94 0 0 1-2 0v12.556A2 2 0 0 1 4 18m14.278 1H5.722a1.94 1.94 0 0 1 0 2h12.556a1.94 1.94 0 0 1 0-2\" opacity=\".25\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default vectorSquareAlt
